import { render, staticRenderFns } from "./LightningTalk.vue?vue&type=template&id=5bb1b2f3&scoped=true&"
import script from "./LightningTalk.vue?vue&type=script&lang=js&"
export * from "./LightningTalk.vue?vue&type=script&lang=js&"
import style0 from "./LightningTalk.vue?vue&type=style&index=0&id=5bb1b2f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb1b2f3",
  null
  
)

export default component.exports